package com.milta.feature.route.presentation

/** User intents for the web dashboard's Supervision screen (MIL-48, DOM-06). */
sealed interface WebDashboardIntent {
    /** Switches to [WebDashboardTab.Today] and (re)loads it. Equivalent to `SwitchTab(Today)` —
     * kept as its own intent since the ticket calls for it explicitly (e.g. a dedicated tab button). */
    data object LoadToday : WebDashboardIntent

    /** Switches to [WebDashboardTab.Tomorrow] and (re)loads it. Equivalent to `SwitchTab(Tomorrow)`. */
    data object LoadTomorrow : WebDashboardIntent

    data class SwitchTab(val tab: WebDashboardTab) : WebDashboardIntent

    /** Manual refetch of the currently selected tab — no automatic polling (explicit PO decision). */
    data object Refresh : WebDashboardIntent

    /** Toggles the stop-detail panel for [routeId] — loads `GET /routes/{id}` via
     * [com.milta.feature.route.domain.usecase.GetRouteDetailUseCase] on first expand, collapses it
     * (no re-fetch) if the same, already-expanded route is clicked again. */
    data class ExpandRoute(val routeId: String) : WebDashboardIntent

    /** Retour client 17/09/2026, point 12 — opens the proof-photo dialog for a Delivered/Failed stop
     * of the currently expanded route and fetches its photo via `GET routes/{routeId}/proofs`. */
    data class ShowProof(val deliveryId: String) : WebDashboardIntent

    /** Closes the proof-photo dialog opened by [ShowProof]. */
    data object DismissProof : WebDashboardIntent

    // ── Filtre statut + chauffeur (MIL-85) ── purely client-side, applied to the already-loaded
    // overview (this screen has no pagination, unlike "Historique des preuves") — never refetches.
    /** Null clears the filter (shows every status). */
    data class SetStatusFilter(val status: com.milta.feature.route.domain.entity.RouteStatus?) : WebDashboardIntent
    /** [driverId] matches [com.milta.feature.route.domain.entity.DriverRouteOverview.driverId];
     * null clears the filter (shows every driver). */
    data class SetDriverFilter(val driverId: String?) : WebDashboardIntent
}
